<div class="card-content set-password-content">
  <h1 class="card-title">{{ 'modify-password-dialog.title' | translate }}</h1>
  <form
    [formGroup]="setPasswordForm"
    (ngSubmit)="onSubmit()"
    class="set-password-form"
  >
  <div class="input-block">
    <label class="input-title input-text-required" for="currentPassword">{{
      'modify-password-dialog.current-password' | translate
    }}</label>
    <div class="input-group input-btn-right">
      <input
        matInput
        [type]="isCurrentPasswordVisible ? 'text' : 'password'"
        [formControl]="currentPasswordControl"
        appAlphaNumericOnly
        [ngClass]="{
          'input-error': showPasswordError && (currentPasswordControl.invalid || passwordErrorMessage),
        }"
        [placeholder]="
          'modify-password-dialog.current-password-placeholder' | translate
        "
      />
      <button
        mat-icon-button
        type="button"
        (click)="toggleCurrentPasswordVisibility()"
        class="input-password-btn"
      >
        <img
          [src]="isCurrentPasswordVisible ? 'assets/img/i-eye.svg' : 'assets/img/i-eye-closed.svg'"
          alt="toggle visibility"
        />
      </button>
    </div>
    @if (showPasswordError && (passwordErrorMessage || currentPasswordControl.invalid)) {
      <mat-error class="input-error-msg">
        {{ passwordErrorMessage || ('error.password-error.required' | translate) }}
      </mat-error>
    }
  </div>

    <div class="input-block">
      <label class="input-title input-text-required" for="password">{{
        'modify-password-dialog.password' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          id="password"
          matInput
          [type]="isNewPasswordVisible ? 'text' : 'password'"
          formControlName="password"
          appAlphaNumericOnly
          [ngClass]="{
            'input-error':
              showFormError && setPasswordForm.get('password')?.invalid,
          }"
          [placeholder]="
            'modify-password-dialog.password-placeholder' | translate
          "
        />
        <button
          mat-icon-button
          type="button"
          (click)="toggleNewPasswordVisibility()"
          class="input-password-btn"
        >
          <img
            [src]="isNewPasswordVisible ? 'assets/img/i-eye.svg' : 'assets/img/i-eye-closed.svg'"
            alt="toggle visibility"
          />
        </button>
      </div>
      <div class="input-warn-msg">
        @if (setPasswordForm.get('password')?.errors?.['length']) {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-disable.svg"
            alt=""
          />
        } @else {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-green.svg"
            alt=""
          />
        }
        <span>{{ 'modify-password-dialog.password-hint1' | translate }}</span>
      </div>
      <div class="input-warn-msg">
        @if (setPasswordForm.get('password')?.errors?.['format']) {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-disable.svg"
            alt=""
          />
        } @else {
          <img
            width="16"
            height="16"
            ngSrc="/assets/img/i-check-green.svg"
            alt=""
          />
        }
        <span>{{ 'modify-password-dialog.password-hint2' | translate }}</span>
      </div>
    </div>
    <div class="input-block">
      <label class="input-title input-text-required" for="re-enter-password">{{
        'modify-password-dialog.re-enter-password' | translate
      }}</label>
      <div class="input-group input-btn-right">
        <input
          id="re-enter-password"
          matInput
          appAlphaNumericOnly
          [type]="isReEnterPasswordVisible ? 'text' : 'password'"
          formControlName="reEnterPassword"
          [ngClass]="{
            'input-error':
              showFormError && setPasswordForm.get('reEnterPassword')?.invalid,
          }"
          [placeholder]="
            'modify-password-dialog.re-enter-password-placeholder' | translate
          "
        />
        <button
          mat-icon-button
          type="button"
          (click)="toggleReEnterPasswordVisibility()"
          class="input-password-btn"
        >
          <img
            [src]="
              isReEnterPasswordVisible
                ? 'assets/img/i-eye.svg'
                : 'assets/img/i-eye-closed.svg'
            "
            alt="toggle visibility"
          />
        </button>
      </div>
      @if (showFormError && setPasswordForm.get('reEnterPassword')?.invalid) {
        <mat-error class="input-error-msg">{{
          getReEnterPasswordErrorMessage()
        }}</mat-error>
      }
    </div>
    <button mat-button type="submit" class="btn-fill-primary btn-size-l">
      {{ 'modify-password-dialog.submit' | translate }}
    </button>
    <button 
      mat-button 
      type="button" 
      (click)="dialogRef.close()" 
      class="btn-outline-secondary btn-size-l"
    >
      {{ 'modify-password-dialog.cancel' | translate }}
    </button>
  </form>
</div>